export default __webpack_public_path__ + "static/media/logo-no-bg.4d881dc9.svg";